// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistant_icon svg[data-v-1b60ded6] {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  display: block;
  cursor: pointer;
}
.animated_icon[data-v-1b60ded6] {
  animation: rotate-1b60ded6 550ms ease;
}
@keyframes rotate-1b60ded6 {
0% {
    transform: rotate(-360deg);
    transition: transform 550ms ease;
}
100% {
    transform: rotate(360deg);
    transition: transform 550ms ease;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/icons/AssistantIcon.vue","webpack://./AssistantIcon.vue"],"names":[],"mappings":"AACA;EACE,0BAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;ACAF;ADGA;EACE,qCAAA;ACDF;ADIA;AACE;IACE,0BAAA;IACA,gCAAA;ACFF;ADKA;IACE,yBAAA;IACA,gCAAA;ACHF;AACF","sourcesContent":["\n.assistant_icon svg {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  display: block;\n  cursor: pointer;\n}\n\n.animated_icon {\n  animation: rotate 550ms ease;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(-360deg);\n    transition: transform 550ms ease;\n  }\n\n  100% {\n    transform: rotate(360deg);\n    transition: transform 550ms ease;\n  }\n}\n",".assistant_icon svg {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  display: block;\n  cursor: pointer;\n}\n.animated_icon {\n  animation: rotate 550ms ease;\n}\n@keyframes rotate {\n  0% {\n    transform: rotate(-360deg);\n    transition: transform 550ms ease;\n  }\n  100% {\n    transform: rotate(360deg);\n    transition: transform 550ms ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
